import StatCard from '@/components/base/StatCard';
import type { ReportKpi } from '@/utils/report';

interface ReportKpiRowProps {
  kpis: ReportKpi[];
}

export default function ReportKpiRow({ kpis }: ReportKpiRowProps) {
  return (
    <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 xl:grid-cols-4">
      {kpis.map((kpi) => (
        <StatCard
          key={kpi.label}
          label={kpi.label}
          value={kpi.value}
          icon={kpi.icon}
          tone={kpi.tone}
          delta={kpi.delta}
          deltaPositive={kpi.deltaPositive}
          hint={kpi.hint}
        />
      ))}
    </div>
  );
}